import { useEffect } from 'react'

import { useErrorHandler } from '../../hooks/useErrorHandler'
import { usePSNavigate } from '../../hooks/usePSNavigate'
import { RecordFactory } from '../../models/RecordFactory'
import { WorkflowPage } from '../workflows/WorkflowPage'

export const SetupDashboardCompletePage = () => {
    const navigate = usePSNavigate()
    const { logAndDisplayError } = useErrorHandler()

    useEffect(() => {
        const setGoLiveComplete = async () => {
            const result = await RecordFactory.getInstance().sendOnboardingState('gl_complete')
            if (!result.ok) {
                logAndDisplayError(result.error)
            }
        }
        setGoLiveComplete()
    }, [])

    return (
        <>
            <WorkflowPage onClose={() => navigate('/')}>
                <div className="flex h-full flex-col items-stretch justify-center">
                    <WorkflowPage.SuccessView
                        title="Let's get you booked!"
                        showConfetti
                        subtitle="You’re setup and ready to go! Want to connect with a member of our Customer Success Team? Schedule a call below!"
                        showLinksAsSingleColumn
                        links={[
                            {
                                id: 'schedule-call',
                                title: 'Have questions before going live?',
                                subtitle:
                                    'Schedule an optional 15-minute call with our Customer Success Team.',
                                icon: 'phone.large',
                                to: '/alert/asap',
                            },

                            {
                                id: 'dashboard',
                                title: 'Dashboard',
                                subtitle: 'View your PocketSuite dashboard',
                                icon: 'home.large',
                                to: '/',
                            },
                        ]}
                    />
                </div>
            </WorkflowPage>

            {/* {showSetupCall && (
                <RequestCallPage forDashboard={true} onClose={() => setShowSetupCall(false)} />
            )} */}
        </>
    )
}
